import * as Preact from 'preact';
import QRious from 'qrious';

export interface Props {
    url: string;
    size?: number;
}

const generateQrCode = (url: string, size: number = 200) =>
    new QRious({ value: url, size }).toDataURL();

/** Display a QR Code of the specified size for the provided URL */
export const Component = (p: Props) => <img src={generateQrCode(p.url, p.size)} alt="QR Code" />;
